import { render, staticRenderFns } from "./SLigoAssistantChatBalloon.vue?vue&type=template&id=b904c4ce&"
import script from "./SLigoAssistantChatBalloon.vue?vue&type=script&lang=ts&"
export * from "./SLigoAssistantChatBalloon.vue?vue&type=script&lang=ts&"
import style0 from "./SLigoAssistantChatBalloon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports